import TypeSelect from './index.vue'

export default TypeSelect
